
function DescontoParceiro(){
    return <>
    
    <h1>Desconto Parceiro</h1>
    </>
}
export default DescontoParceiro;